// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero,.hero img{max-height:calc(var(--win-height)*.75)}.hero{position:relative}.hero,.hero__default,.hero__hover{display:block;width:100%}.hero__default img,.hero__hover img{max-width:100%;-o-object-fit:contain;object-fit:contain;-o-object-position:center;object-position:center;width:auto}@media (max-height:768px){.hero,.hero img{max-height:calc(var(--win-height)/2)}}@media (min-height:860px){.hero,.hero img{max-height:calc(var(--win-height)/2)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
